import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import {
    getCommonInfo,
    getPAJAC030Goods,
    getPAJAC020Ticket,
    getPAJAC020BusinessDate,
    getPAJAC050Details,
    postPAJAC020PaymentTicket,
    postPAJAC030PaymentTicket,
    postPayment,
    getRecruitReadyYN
} from '../../../../services/Api';
import Dropdown from '../../../../shared/components/Dropdown';
import { getVbankExpireAfterDays } from '../../../../shared/components/VBankDate';
import { decodeToken, formatNumberWithCommas, handleFocus } from '../../../../utils';

// Ghép tên + giá 덴탈잡 đang áp dụng từ DB vào 1 sản phẩm, giữ nguyên các field vé/ngày.
// goodCode của trang là mã cũ, khớp với cột LegacyCode trong tblGoods_Master (admin MAAAA001).
// Sản phẩm không có trong bảng (5002 고정옵션 14일, 아이콘 강조) vẫn giữ tên/giá cố định.
const applyGoodsInfo = (item, goodsByLegacyCode) => {
    const goods = goodsByLegacyCode[item.goodCode];
    if (!goods || goods.priceDJ == null) return item;

    const price = Number(goods.priceDJ);
    return {
        ...item,
        name: goods.goodName,
        price,
        selectedPrice: item.duration === 14 && item.price14 ? item.price14 : price,
    };
};

const PAJAC030 = ({ updateUserData }) => {
    const navigate = useNavigate();
    const startDateRefBanner = useRef(null);
    const startDateRefFixed = useRef(null);
    const startDateRefHighlight = useRef(null);
    const [searchParams] = useSearchParams();
    const option = searchParams.get('option') === 'true';
    const type = searchParams.get('type');
    const [appGbnCd, setAppGbnCd] = useState('');
    const [ticketPay, setTicketPay] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);
    const [productData, setProductData] = useState({
        banner: [
            {
                goodCode: '011',
                name: '비즈니스 배너',
                price: 950000,
                duration: 7,
                ticketCode: '011',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                showBanner: false,
                ticketSeqToUse: 0,
            },
            {
                goodCode: '002',
                name: '그랜드 배너 (채용소식 포함)',
                price: 400000,
                duration: 7,
                ticketCode: '002',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                showBanner: false,
                ticketSeqToUse: 0,
                option: {
                    goodCode: '6000',
                    name: '고정옵션 (그랜드 배너)',
                    price: 60000,
                    duration: 7,
                    ticketCode: '6000',
                    ticketNumber: 0,
                    ticketSeqToUse: 0,
                },
            },
            // {
            //     goodCode: '0023',
            //     name: '그랜드 배너 (채용광고 디자인 서비스 포함)',
            //     price: 0,
            //     duration: 7,
            //     ticketCode: '0023',
            //     ticketNumber: 0,
            //     startDate: moment().format('YYYY-MM-DD'),
            //     showBanner: false,
            //     ticketOnly: true,
            //     ticketSeqToUse: 0,
            // },
            {
                goodCode: '003',
                name: '프리미엄 배너 (채용소식 포함)',
                price: 210000,
                duration: 7,
                ticketCode: '003',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                showBanner: false,
                ticketSeqToUse: 0,
                option: {
                    goodCode: '7000',
                    name: '고정옵션 (프리미엄 배너)',
                    price: 60000,
                    duration: 7,
                    ticketCode: '7000',
                    ticketNumber: 0,
                    ticketSeqToUse: 0,
                },
            },
            // {
            //     goodCode: '0033',
            //     name: '프리미엄 배너 (채용광고 디자인 서비스 포함)',
            //     price: 0,
            //     duration: 7,
            //     ticketCode: '0033',
            //     ticketNumber: 0,
            //     startDate: moment().format('YYYY-MM-DD'),
            //     showBanner: false,
            //     ticketOnly: true,
            //     ticketSeqToUse: 0,
            // },
            {
                goodCode: '010',
                name: '기업 배너',
                price: 440000,
                duration: 7,
                ticketCode: '010',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                showBanner: true,
                hideTicket: true,
                ticketSeqToUse: 0,
            },
            {
                goodCode: '008',
                name: '핫리쿠르트 배너 (채용소식 포함)',
                price: 135000,
                duration: 7,
                ticketCode: '008',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                showBanner: false,
                ticketSeqToUse: 0,
                option: {
                    goodCode: '4000',
                    name: '고정옵션 (핫리쿠르트 배너)',
                    price: 60000,
                    duration: 7,
                    ticketCode: '4000',
                    ticketNumber: 0,
                    ticketSeqToUse: 0,
                },
            },
            {
                goodCode: '001',
                name: '채용소식',
                price: 60000,
                duration: 14,
                ticketCode: '001',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                showBanner: false,
                ticketSeqToUse: 0,
            },
        ],
        fixed: [
            {
                goodCode: '5000',
                goodCode14: '5002',
                selectedGoodCode: '5000',
                name: '고정옵션 (채용소식)',
                selectedPrice: 60000,
                price: 60000,
                price14: 120000,
                duration: 7,
                selectedTicket: '5000',
                ticketCode: '5000',
                ticketCode14: '5002',
                ticketNumber: 0,
                selectedTicketNumber: 0,
                settingDuration: true,
                startDate: moment().format('YYYY-MM-DD'),
                ticketSeqToUse: 0,
            },
        ],
        highlight: [
            {
                goodCode: '1000',
                name: '하이라이트 강조 1주',
                price: 12000,
                duration: 7,
                ticketCode: '1000',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                ticketSeqToUse: 0,
            },
            {
                goodCode: '1500',
                name: '하이라이트 강조 2주',
                price: 18000,
                duration: 14,
                ticketCode: '1500',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                ticketSeqToUse: 0,
            },
            {
                goodCode: '2000',
                name: '컬러 강조 1주',
                price: 10000,
                duration: 7,
                ticketCode: '2000',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                ticketSeqToUse: 0,
            },
            {
                goodCode: '2500',
                name: '컬러 강조 2주',
                price: 15000,
                duration: 14,
                ticketCode: '2500',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                ticketSeqToUse: 0,
            },
            {
                goodCode: '3010',
                name: '아이콘 강조 1주 (주목)',
                price: 8000,
                duration: 7,
                ticketCode: '3000',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                ticketSeqToUse: 0,
            },
            {
                goodCode: '3020',
                name: '아이콘 강조 1주 (HOT)',
                price: 8000,
                duration: 7,
                ticketCode: '3000',
                startDate: moment().format('YYYY-MM-DD'),
                ticketSeqToUse: 0,
            },
            {
                goodCode: '3510',
                name: '아이콘 강조 2주 (주목)',
                price: 12000,
                duration: 14,
                ticketCode: '3500',
                ticketNumber: 0,
                startDate: moment().format('YYYY-MM-DD'),
                ticketSeqToUse: 0,
            },
            {
                goodCode: '3520',
                name: '아이콘 강조 2주 (HOT)',
                price: 12000,
                duration: 14,
                ticketCode: '3500',
                startDate: moment().format('YYYY-MM-DD'),
                ticketSeqToUse: 0,
            },
        ],
    });

    const [payload, setPayload] = useState({
        banner: [],
        bannerOp: [],
        fixed: [],
        highlight: [],
    });

    const [payloadTicket, setPayloadTicket] = useState({
        banner: [],
        bannerOp: [],
        fixed: [],
        highlight: [],
    });
    const today = moment().startOf('day');
    const [ticketData, setTicketData] = useState([]);
    const [goodCode, setGoodCode] = useState('');
    const [goodName, setGoodName] = useState('');
    const [ticketSeq, setTicketSeq] = useState('');
    const [totalPay, setTotalPay] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('Card');
    const [payloadReceipt, setPayloadReceipt] = useState({
        receiptType: 'company',
    });

    const [selectedProduct, setSelectedProduct] = useState({});

    const { id } = useParams();

    const token = useSelector(({ auth }) => auth.login.token);
    const [mSeq, setMSeq] = useState('');

    const [recruitEnd, setRecruitEnd] = useState('');
    const [recruitFrom, setRecruitFrom] = useState('');

    const [businessStart, setBusinessStart] = useState(null);
    const [businessEnd, setBusinessEnd] = useState(null);
    const [businessMin, setBusinessMin] = useState(null);
    const [isBusiness, setIsBusiness] = useState(false);

    useEffect(() => {
        if (option) {
            getPAJAC050Details(type, id)
                .then(({ data }) => {
                    setRecruitEnd(moment(data.recruitEnd).format('YYYY-MM-DD'));
                    setRecruitFrom(moment(data.recruitFrom).format('YYYY-MM-DD'));
                })
                .catch((error) => console.log(error));
        } else {
            getRecruitReadyYN({
                params: {
                    seq: id
                },
            })
                .then((response) => {
                    if (response.data === 'not_exist') {
                        window.alert('존재하지 않는 링크입니다');
                        navigate('/');
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }, [id, option, type]);

    useEffect(() => {
        getCommonInfo()
            .then(({ data }) => {
                setAppGbnCd(data?.appGbnCd);

                if (!option && data?.appGbnCd !== '999') {
                    setPayload((prevPayload) => ({
                        ...prevPayload,
                        banner: ['001'],
                    }));
                }
                if (!option && data?.appGbnCd === '999') {
                    setPayload((prevPayload) => ({
                        ...prevPayload,
                        banner: ['010'],
                    }));
                }

                setPayloadReceipt((prev) => ({
                    ...prev,
                    ...data,
                    receiptType: data.receiptType || prev.receiptType,
                }));
            })
            .catch((error) => console.log(error));
        getPAJAC020Ticket()
            .then(({ data }) => {
                const ticketData = Array.isArray(data) ? data : [];

                if (Array.isArray(data) && data.some((item) => item.goodNameCode === '001')) {
                    setPayloadTicket((prevTicket) => ({
                        ...prevTicket,
                        banner: ['001'],
                    }));
                }

                const ticketCount = Array.isArray(data)
                    ? data.reduce((acc, item) => {
                        if (item.goodNameCode) {
                            acc[item.goodNameCode] = (acc[item.goodNameCode] || 0) + 1;
                        }
                        return acc;
                    }, {})
                    : {};

                const updateProductData = (categories) => {
                    return categories.map((item) => {
                        const newTicketNumber = ticketCount[item.ticketCode] || 0;
                        const newTicketNumber14 = item.ticketCode14 ? ticketCount[item.ticketCode14] || 0 : 0;
                        const selectedTicketNumber =
                            item.ticketCode14 && item.duration === 14 ? newTicketNumber14 : newTicketNumber;
                        const ticketItem = ticketData.find(
                            (d) =>
                                d.goodNameCode === item.ticketCode ||
                                (item.ticketCode14 && d.goodNameCode === item.ticketCode14),
                        );
                        const ticketSeqToUse = ticketItem ? ticketItem.seq : item.ticketSeqToUse || 0;

                        const optionTicketItem = item.option
                            ? ticketData.find((d) => d.goodNameCode === item.option.ticketCode)
                            : null;
                        const optionTicketSeqToUse = optionTicketItem
                            ? optionTicketItem.seq
                            : item.option?.ticketSeqToUse || 0;
                        return {
                            ...item,
                            selectedPrice: item.duration === 14 && item.price14 ? item.price14 : item.price,
                            selectedTicket:
                                item.duration === 14 && item.ticketCode14 ? item.ticketCode14 : item.ticketCode,
                            selectedTicketNumber,
                            ticketNumber: newTicketNumber,
                            ticketNumber14: newTicketNumber14,
                            ticketSeqToUse,
                            option: item.option
                                ? {
                                    ...item.option,
                                    ticketNumber: ticketCount[item.option.ticketCode] || 0,
                                    ticketSeqToUse: optionTicketSeqToUse,
                                }
                                : undefined,
                        };
                    });
                };

                setProductData((prevData) => ({
                    banner: updateProductData(prevData.banner),
                    fixed: updateProductData(prevData.fixed),
                    highlight: updateProductData(prevData.highlight),
                }));
                if (data === 'empty') {
                    setTicketData([]);
                    return;
                } else {
                    setTicketData(data);
                }
            })
            .catch((error) => console.log(error));

        getPAJAC030Goods()
            .then(({ data }) => {
                const goodsByLegacyCode = Object.fromEntries(
                    (data || []).filter((goods) => goods.legacyCode).map((goods) => [goods.legacyCode, goods]),
                );
                const mergeGoods = (items) =>
                    items.map((item) => ({
                        ...applyGoodsInfo(item, goodsByLegacyCode),
                        option: item.option ? applyGoodsInfo(item.option, goodsByLegacyCode) : undefined,
                    }));

                setProductData((prevData) => ({
                    banner: mergeGoods(prevData.banner),
                    fixed: mergeGoods(prevData.fixed),
                    highlight: mergeGoods(prevData.highlight),
                }));
            })
            .catch((error) => console.log(error));

        const script = document.createElement('script');
        script.src = 'https://stgstdpay.inicis.com/stdjs/INIStdPay.js';
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const handleCheckboxChange = (name, item, parentGoodCode = null) => {
        setPayload((prevPayload) => {
            let updatedSelection = [];

            setPayloadTicket((prevTicket) => ({
                ...prevTicket,
                [name]: prevPayload[name].includes(item.selectedGoodCode || item.goodCode)
                    ? prevTicket[name].filter((code) => code !== item.ticketCode)
                    : [item.ticketCode],
            }));

            if (name === 'banner' || name === 'fixed' || name === 'highlight') {
                if (name === 'banner') {
                    if (item.goodCode === '011') {
                        setIsBusiness(true);

                        getPAJAC020BusinessDate()
                            .then(({ data }) => {
                                const start = moment(data.startDate, 'YYYY-MM-DD').toDate();
                                const end = moment(data.endDate, 'YYYY-MM-DD').toDate();

                                setBusinessStart(start);
                                setBusinessEnd(end);
                                setBusinessMin(start);

                                setSelectedProduct(prev => ({
                                    ...prev,
                                    banner: {
                                        ...prev.banner,
                                        endDate: moment(end).format('YYYY-MM-DD'),
                                        startDate: moment(start).format('YYYY-MM-DD')
                                    }
                                }));

                                handleDateChange('banner', moment(start).format('YYYY-MM-DD'));
                            });
                    } else {
                        setIsBusiness(false);
                        setBusinessStart(today.toDate());
                        setBusinessMin(today.toDate());
                        setBusinessEnd(null);

                        // Reset banner startDate về today và đồng bộ highlight/fixed
                        const todayStr = moment().format('YYYY-MM-DD');
                        setSelectedProduct(prev => ({
                            ...prev,
                            banner: {
                                ...prev.banner,
                                startDate: todayStr
                            }
                        }));
                    }
                }

                const isChangingBanner = name === 'banner' && prevPayload.banner.length > 0;

                updatedSelection = prevPayload[name].includes(item.selectedGoodCode || item.goodCode)
                    ? []
                    : [item.selectedGoodCode || item.goodCode];
                if (
                    (name === 'highlight' || name === 'fixed') &&
                    updatedSelection.length > 0
                ) {
                    setSelectedProduct(prev => ({
                        ...prev,
                        [name]: {
                            ...prev[name],
                            startDate: prev[name]?.startDate || prev.banner?.startDate
                        }
                    }));
                }

                if (name === 'banner' && item.option !== undefined) {
                    if (item.option.ticketNumber > 0) {
                        setPayloadTicket((prevTicket) => ({
                            ...prevTicket,
                            bannerOp: item.option.goodCode ? [item.option.goodCode] : [],
                        }));
                        return {
                            ...prevPayload,
                            banner: updatedSelection,
                            bannerOp: item.option.goodCode ? [item.option.goodCode] : [],
                        };
                    } else {
                        setPayloadTicket((prevTicket) => ({
                            ...prevTicket,
                            bannerOp: [],
                        }));
                        return {
                            ...prevPayload,
                            banner: updatedSelection,
                            bannerOp: [],
                        };
                    }
                }

                if (isChangingBanner || (name === 'banner' && updatedSelection.length === 0)) {
                    return {
                        ...prevPayload,
                        [name]: updatedSelection,
                        bannerOp: [],
                    };
                }

            } else if (name === 'bannerOp') {
                if (prevPayload.banner.includes(parentGoodCode)) {
                    updatedSelection = prevPayload.bannerOp.includes(item.goodCode)
                        ? prevPayload.bannerOp.filter((code) => code !== item.goodCode)
                        : [...prevPayload.bannerOp, item.goodCode];

                    if (!updatedSelection.includes(item.goodCode)) {
                        setPayloadTicket((prevTicket) => ({
                            ...prevTicket,
                            bannerOp: prevTicket.bannerOp.filter((code) => code !== item.goodCode),
                        }));
                    }
                }
                return { ...prevPayload, bannerOp: updatedSelection };
            }

            return { ...prevPayload, [name]: updatedSelection };
        });
    };


    const handleApplyTicket = (category, ticketCode) => {
        setPayloadTicket((prevTicket) => {
            let updatedSelection = prevTicket[category].includes(ticketCode)
                ? prevTicket[category].filter((code) => code !== ticketCode)
                : [ticketCode];

            return { ...prevTicket, [category]: updatedSelection };
        });
    };

    const isTicketDisabled = (category, ticketCode) => {
        let item;

        if (category === 'banner') {
            item = productData.banner.find((b) => b.ticketCode === ticketCode || b.ticketCode14 === ticketCode);
        } else if (category === 'bannerOp') {
            item = productData.banner.flatMap((b) => b.option || []).find((op) => op.ticketCode === ticketCode);
        } else if (category === 'fixed') {
            item = productData.fixed.find((b) => b.ticketCode === ticketCode || b.ticketCode14 === ticketCode);
        } else if (category === 'highlight') {
            item = productData.highlight.find((h) => h.ticketCode === ticketCode);
        }

        if (!item) return true;

        let isTicketAvailable;

        if (category === 'fixed') {
            const isUsingTicket14 = item.selectedTicket === item.ticketCode14;
            isTicketAvailable = isUsingTicket14 ? item.ticketNumber14 > 0 : item.ticketNumber > 0;
        } else {
            // Với `bannerOp`, `highlight` -> Chỉ kiểm tra ticketNumber
            isTicketAvailable = item.ticketNumber > 0;
        }

        const isParentChecked = payload[category]?.includes(item?.goodCode);

        if (category === 'highlight') {
            if (['3010', '3020'].includes(item.goodCode)) {
                return (
                    !isTicketAvailable || (!payload.highlight.includes('3010') && !payload.highlight.includes('3020'))
                );
            }
            if (['3510', '3520'].includes(item.goodCode)) {
                return (
                    !isTicketAvailable || (!payload.highlight.includes('3510') && !payload.highlight.includes('3520'))
                );
            }
        }

        return !isTicketAvailable || !isParentChecked;
    };

    // kiểm tra và bỏ chọn ticket nếu bị disable
    useEffect(() => {
        setPayloadTicket((prevTicket) => {
            let updatedTickets = { ...prevTicket };

            Object.keys(prevTicket).forEach((category) => {
                updatedTickets[category] = prevTicket[category].filter(
                    (ticketCode) => !isTicketDisabled(category, ticketCode),
                );
            });

            return updatedTickets;
        });
        // eslint-disable-next-line
    }, [payload]);

    const handleChangeDuration = (selectedValue, name) => {
        const productName = name.split('_')[1];
        const goodCode = name.split('_')[2];
        const is14 = selectedValue === '14';

        setProductData((prevData) => ({
            ...prevData,
            [productName]: prevData[productName].map((item) => {
                if (item.selectedGoodCode === goodCode || item.goodCode === goodCode) {
                    return {
                        ...item,
                        duration: is14 ? 14 : 7,
                        selectedPrice: is14 ? item.price14 : item.price,
                        selectedTicketNumber: is14 ? item.ticketNumber14 : item.ticketNumber,
                        selectedTicket: is14 ? item.ticketCode14 : item.ticketCode,
                        selectedGoodCode: is14 ? item.goodCode14 : item.goodCode,
                    };
                }

                return item;
            }),
        }));

        setPayload((prevPayload) => {
            const newFixedValue = prevPayload.fixed[0] === '5000' ? '5002' : '5000';

            return {
                ...prevPayload,
                fixed: [newFixedValue],
            };
        });

        setPayloadTicket((prevPayload) => ({
            ...prevPayload,
            [productName]: prevPayload[productName].filter(
                (ticket) =>
                    !productData[productName].some(
                        (item) =>
                            (item.selectedGoodCode === goodCode || item.goodCode === goodCode) &&
                            (item.ticketCode === ticket || item.ticketCode14 === ticket),
                    ),
            ),
        }));
    };

    useEffect(() => {
        let selectedItems = {};

        if (payload.banner.length > 0) {
            const selectedBanner = productData.banner.find((item) => payload.banner.includes(item.goodCode));
            if (selectedBanner) {
                const { option, ...selectedBannerInfo } = selectedBanner;
                selectedItems.banner = selectedBannerInfo;
            }
        }

        if (payload.bannerOp.length > 0) {
            const selectedBannerOp = productData.banner
                .flatMap((item) => item.option || [])
                .find((op) => payload.bannerOp.includes(op.goodCode));
            if (selectedBannerOp) selectedItems.bannerOp = selectedBannerOp;
        }

        if (payload.fixed.length > 0) {
            const selectedFixed = productData.fixed.find(
                (item) => payload.fixed.includes(item.goodCode) || payload.fixed.includes(item.goodCode14),
            );
            if (selectedFixed) selectedItems.fixed = selectedFixed;
        }

        if (payload.highlight.length > 0) {
            const selectedHighlight = productData.highlight.find((item) => payload.highlight.includes(item.goodCode));
            if (selectedHighlight) selectedItems.highlight = selectedHighlight;
        }

        setSelectedProduct(prev => {
            const newSelected = { ...selectedItems };
            if (newSelected.banner && prev?.banner?.startDate) {
                newSelected.banner.startDate = prev.banner.startDate;

                // goodCode 바뀌면 새 duration으로 endDate 재계산, 같으면 이전 endDate 유지
                if (newSelected.banner.goodCode === prev.banner?.goodCode && prev.banner?.endDate) {
                    newSelected.banner.endDate = prev.banner.endDate;
                } else {
                    const startMoment = moment(prev.banner.startDate, 'YYYY-MM-DD');
                    const durationDays = Math.max((newSelected.banner.duration ?? 1) - 1, 0);
                    let endMoment = startMoment.clone().add(durationDays, 'days');
                    if (recruitEnd && endMoment.isAfter(moment(recruitEnd, 'YYYY-MM-DD'))) {
                        endMoment = moment(recruitEnd, 'YYYY-MM-DD');
                    }
                    newSelected.banner.endDate = endMoment.format('YYYY-MM-DD');
                }
            }
            if (selectedItems?.banner?.goodCode === '011') {
                newSelected.banner = {
                    ...selectedItems.banner,
                    startDate: moment(businessStart).format('YYYY-MM-DD'),
                    endDate: moment(businessEnd).format('YYYY-MM-DD'),
                };
            }

            return {
                ...(payload.banner.length > 0 && newSelected.banner ? { banner: newSelected.banner } : {}),
                ...(payload.bannerOp.length > 0 && newSelected.bannerOp ? { bannerOp: newSelected.bannerOp } : {}),
                ...(payload.fixed.length > 0 && newSelected.fixed ? { fixed: newSelected.fixed } : {}),
                ...(payload.highlight.length > 0 && newSelected.highlight ? { highlight: newSelected.highlight } : {}),
            };
        });

    }, [payload, payloadTicket, productData, businessStart, businessEnd]);

    const handleDateChange = (category, date) => {
        if (category === 'banner') {
            setBusinessStart(date);
        }

        const startDate = moment(date, 'YYYY-MM-DD');

        const durationDays = Math.max((selectedProduct?.[category]?.duration ?? 1) - 1, 0);

        let endDate = startDate.clone().add(durationDays, 'days');

        // if (isBusiness && businessEnd != null) {
        //     endDate = moment.min(endDate, moment(businessEnd, 'YYYY-MM-DD'));
        // }


        if (category === 'banner' && isBusiness && businessEnd != null) {
            endDate = moment.min(endDate, moment(businessEnd, 'YYYY-MM-DD'));
        }


        if (recruitEnd && endDate.isAfter(moment(recruitEnd, 'YYYY-MM-DD'))) {
            endDate = moment(recruitEnd, 'YYYY-MM-DD');
        }

        setSelectedProduct((prevProduct) => {
            const updatedProduct = {
                ...prevProduct,
                [category]: {
                    ...prevProduct[category],
                    startDate: startDate.format('YYYY-MM-DD'),
                    endDate: endDate.format('YYYY-MM-DD'),
                },
            };

            if (category === 'banner') {
                const bannerStartDate = moment(updatedProduct.banner.startDate, 'YYYY-MM-DD');

                // Luôn đồng bộ fixed với banner
                if (updatedProduct.fixed?.startDate) {
                    updatedProduct.fixed.startDate = bannerStartDate.format('YYYY-MM-DD');
                    const fixedEndDate = bannerStartDate.clone().add(updatedProduct.fixed.duration - 1 || 0, 'days');
                    updatedProduct.fixed.endDate = fixedEndDate.isAfter(moment(recruitEnd, 'YYYY-MM-DD'))
                        ? moment(recruitEnd, 'YYYY-MM-DD').format('YYYY-MM-DD')
                        : fixedEndDate.format('YYYY-MM-DD');
                }

                // Luôn đồng bộ highlight với banner
                if (updatedProduct.highlight?.startDate) {
                    updatedProduct.highlight.startDate = bannerStartDate.format('YYYY-MM-DD');
                    const highlightEndDate = bannerStartDate.clone().add(updatedProduct.highlight.duration - 1 || 0, 'days');
                    updatedProduct.highlight.endDate = highlightEndDate.isAfter(moment(recruitEnd, 'YYYY-MM-DD'))
                        ? moment(recruitEnd, 'YYYY-MM-DD').format('YYYY-MM-DD')
                        : highlightEndDate.format('YYYY-MM-DD');
                }
            }

            return updatedProduct;
        });
    };

    useEffect(() => {
        setTotalPay(
            (payloadTicket.banner.includes(selectedProduct?.banner?.ticketCode) ||
                payloadTicket.banner.includes(selectedProduct?.banner?.ticketCode14)
                ? 0
                : selectedProduct?.banner?.selectedPrice || 0) +
            (payloadTicket.bannerOp.includes(selectedProduct?.bannerOp?.ticketCode) ||
                payloadTicket.bannerOp.includes(selectedProduct?.bannerOp?.ticketCode14)
                ? 0
                : selectedProduct?.bannerOp?.price || 0) +
            (payloadTicket.fixed.includes(selectedProduct?.fixed?.ticketCode) ||
                payloadTicket.fixed.includes(selectedProduct?.fixed?.ticketCode14)
                ? 0
                : selectedProduct?.fixed?.selectedPrice || 0) +
            (payloadTicket.highlight.includes(selectedProduct?.highlight?.ticketCode)
                ? 0
                : selectedProduct?.highlight?.price || 0),
        );
        setGoodCode(
            [
                selectedProduct?.banner?.goodCode,
                selectedProduct?.bannerOp?.goodCode,
                selectedProduct?.fixed?.selectedGoodCode || selectedProduct?.fixed?.goodCode,
                selectedProduct?.highlight?.goodCode,
            ]
                .filter(Boolean)
                .join(','),
        );
        setGoodName(
            [
                selectedProduct?.banner?.name,
                selectedProduct?.bannerOp?.name,
                selectedProduct?.fixed?.name,
                selectedProduct?.highlight?.name,
            ]
                .filter(Boolean)
                .join(','),
        );

        const selectedSeqs = Object.values(payloadTicket)
            .flat()
            .map((ticketCode) => {
                const matchingTickets = Array.isArray(ticketData)
                    ? ticketData.filter((ticket) => ticket.goodNameCode === ticketCode)
                    : [];
                return matchingTickets.length > 0 ? matchingTickets[0].seq : null;
            })
            .filter(Boolean);
        setTicketSeq(selectedSeqs.join(','));

        // eslint-disable-next-line
    }, [selectedProduct, payloadTicket]);

    useEffect(() => {
        setMSeq(decodeToken(token).seq);
    }, [token]);

    const handleChangeReceipt = (e) => {
        const { value, name } = e.target;
        const regex = /^[0-9]*$/;
        if (name === 'receiptNum' && !regex.test(value)) {
            return;
        }

        setPayloadReceipt((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateReceiptCompany = (insertNum) => {
        if (!insertNum) return;
        const regsplitNum = insertNum
            .replace(/-/gi, '')
            .split('')
            .map(function (item) {
                return parseInt(item, 10);
            });

        if (regsplitNum.length === 10) {
            const regkey = [1, 3, 7, 1, 3, 7, 1, 3, 5];
            let regNumSum = 0;
            for (var i = 0; i < regkey.length; i++) {
                regNumSum += regkey[i] * regsplitNum[i];
            }
            regNumSum += parseInt((regkey[8] * regsplitNum[8]) / 10, 10);
            const regCheck = Math.floor(regsplitNum[9]) === (10 - (regNumSum % 10)) % 10;

            return regCheck;
        }
        return false;
    };

    const validatePaymentDetails = () => {
        if (!payloadReceipt.nameKor || !payloadReceipt.mobileNo || !payloadReceipt.email) {
            alert('결제자 정보 입력해 주세요.');
            if (!payloadReceipt.nameKor) {
                handleFocus('nameKor');
            } else if (!payloadReceipt.mobileNo) {
                handleFocus('mobileNo');
            }
            return false;
        }

        if (!/^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}$/.test(payloadReceipt.mobileNo)) {
            alert('입력하신 휴대폰 번호가 올바른 형식이 아닙니다.\n다시 확인해 주세요. (예: 010-1234-5678)');
            handleFocus('mobileNo');
            return false;
        }

        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(payloadReceipt.email)) {
            alert('유효하지 않은 이메일 주소입니다.');
            handleFocus('email');
            return false;
        }

        if (payloadReceipt.nameKor.length >= 50) {
            alert('이름 길이가 적합하지 않습니다.');
            handleFocus('nameKor');
            return false;
        }

        if (
            (paymentMethod === 'DirectBank' || paymentMethod === 'VBank') &&
            (payloadReceipt.receiptNum === undefined || payloadReceipt.receiptNum === '')
        ) {
            alert('현금영수증을 신청할 번호를 입력해 주세요.');
            handleFocus('receiptNum');
            return false;
        }

        if (
            (paymentMethod === 'DirectBank' || paymentMethod === 'VBank') &&
            payloadReceipt.receiptType === 'company' &&
            !validateReceiptCompany(payloadReceipt?.receiptNum)
        ) {
            alert('현금영수증을 신청번호(사업자번호)가 올바르지 않습니다.');
            handleFocus('receiptNum');
            return false;
        } else if (
            (paymentMethod === 'DirectBank' || paymentMethod === 'VBank') &&
            payloadReceipt.receiptType === 'person' &&
            !/^010[0-9]{8}$/.test(payloadReceipt?.receiptNum)
        ) {
            alert(`현금영수증 신청번호(사업자번호)가 올바르지 않습니다. 
- 없이 입력해 주세요. (예: 01012345678)
`);
            handleFocus('receiptNum');
            return false;
        }

        return true;
    };

    // const originalDate = (type) => {
    //     let orgDate = moment().add(type?.duration - 1, 'days');

    //     const recruitEndDate = moment(recruitEnd, 'YYYY-MM-DD');

    //     if (recruitEnd && orgDate.isAfter(recruitEndDate)) {
    //         orgDate = recruitEndDate;
    //     }
    //     return orgDate.format('YYYY-MM-DD');
    // };
    const originalDate = (type) => {
        const baseDate = type?.startDate ? moment(type.startDate, 'YYYY-MM-DD') : moment();
        let orgDate = baseDate.clone().add(type?.duration - 1, 'days');

        const recruitEndDate = moment(recruitEnd, 'YYYY-MM-DD');

        if (recruitEnd && orgDate.isAfter(recruitEndDate)) {
            orgDate = recruitEndDate;
        }
        return orgDate.format('YYYY-MM-DD');
    };

    const renderBannerRows = (showBannerCondition) => {
        return productData.banner
            .filter((item) => item.showBanner === showBannerCondition)
            .map((item, index) => (
                <React.Fragment key={'banner' + index}>
                    <tr>
                        <td className="center">
                            <input
                                type="radio"
                                className="rgst__checkbox"
                                name="banner"
                                value={item.goodCode}
                                checked={payload.banner.includes(item.goodCode)}
                                onChange={() => handleCheckboxChange('banner', item)}
                                disabled={item.ticketOnly && item.ticketNumber === 0}
                            />
                        </td>
                        <td>{item.name}</td>
                        <td className={`${item.settingDuration ? 'pd9' : ''} center`}>{item.duration}일</td>
                        <td className="text-end">
                            {item.ticketOnly ? '-' : `${formatNumberWithCommas(item.price)}원`}{' '}
                        </td>
                        <td className={`center ${item.ticketNumber > 0 ? 'blue' : ''}`}>
                            {item.hideTicket === true ? '' : `${item.ticketNumber}개`}
                        </td>
                        <td className="center">
                            {item.hideTicket === true ? (
                                ''
                            ) : (
                                <input
                                    type="checkbox"
                                    className="rgst__checkbox"
                                    value={item.selectedTicket}
                                    checked={payloadTicket.banner.includes(item.selectedTicket)}
                                    disabled={isTicketDisabled('banner', item.selectedTicket, item?.option?.goodCode)}
                                    onChange={() =>
                                        item?.ticketOnly ? null : handleApplyTicket('banner', item.selectedTicket)
                                    }
                                />
                            )}
                        </td>
                    </tr>
                    {item.option && (
                        <tr className="option">
                            <td className="center">
                                <input
                                    type="checkbox"
                                    className="rgst__checkbox"
                                    name="bannerOp"
                                    value={item.option.goodCode}
                                    checked={payload.bannerOp.includes(item.option.goodCode)}
                                    disabled={!payload.banner.includes(item.goodCode)}
                                    onChange={() => handleCheckboxChange('bannerOp', item.option, item.goodCode)}
                                />
                            </td>
                            <td>∟ {item.option.name}</td>
                            <td className="center">{item.option.duration}일</td>
                            <td className="text-end">{formatNumberWithCommas(item.option.price)}원</td>
                            <td className={`center ${item.option.ticketNumber > 0 ? 'blue' : ''}`}>
                                {item.option.ticketNumber}개
                            </td>
                            <td className="center">
                                <input
                                    type="checkbox"
                                    className="rgst__checkbox"
                                    value={item.option.ticketCode}
                                    checked={payloadTicket.bannerOp.includes(item.option.ticketCode)}
                                    disabled={isTicketDisabled('bannerOp', item.option.ticketCode)}
                                    onChange={() => handleApplyTicket('bannerOp', item.option.ticketCode)}
                                />
                            </td>
                        </tr>
                    )}
                </React.Fragment>
            ));
    };

    const processBannerData = (input) => {
        const output = {
            ticket: {},
            payment: {},
        };

        const keys = ['banner', 'bannerOp', 'fixed', 'highlight'];

        keys.forEach((key) => {
            const item = input[key];
            if (!item) return;

            if (key === 'bannerOp') {
                if (item.ticketNumber > 0) {
                    output.ticket[key] = { ...item };
                }
            } else {
                if (item.selectedTicketNumber > 0) {
                    output.ticket[key] = { ...item, goodCode: item.selectedGoodCode || item.goodCode };
                }
            }

            if (key === 'bannerOp') {
                if (item.ticketNumber === 0) {
                    output.payment[key] = { ...item };
                }
            } else {
                if (item.selectedTicketNumber === 0) {
                    output.payment[key] = { ...item, goodCode: item.selectedGoodCode || item.goodCode };
                }
            }
        });
        const payloadTicketSafe = payloadTicket || { banner: [], bannerOp: [], fixed: [], highlight: [] };

        Object.keys(output.ticket).forEach((key) => {
            const item = output.ticket[key];
            const ticketCode = item.selectedTicket || item.ticketCode;
            const payloadArray = payloadTicketSafe[key] || [];

            if (!payloadArray.includes(ticketCode)) {
                output.payment[key] = { ...item, goodCode: item.selectedGoodCode || item.goodCode };
                delete output.ticket[key];
            }
        });
        if (Object.keys(output.ticket).length === 0) delete output.ticket;
        if (Object.keys(output.payment).length === 0) delete output.payment;

        return output;
    };

    useEffect(() => {
        const totalPayloadCount = Object.values(payload).reduce((acc, list) => acc + list.length, 0);
        const totalPayloadTicketCount = Object.values(payloadTicket).reduce((acc, list) => acc + list.length, 0);
        if (totalPayloadTicketCount > 0 && totalPayloadCount === totalPayloadTicketCount) {
            setTicketPay(true);
        } else {
            setTicketPay(false);
        }
    }, [payload, payloadTicket]);

    const detectDevice = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        const platform = navigator.platform.toLowerCase();

        if (/android/.test(userAgent)) {
            return 'android';
        } else if (/iphone|ipad|ipod/.test(userAgent)) {
            return 'ios';
        } else if (/mac/.test(platform)) {
            return 'mac';
        } else if (/win/.test(platform)) {
            return 'windows';
        } else {
            return 'Unknown';
        }
    };

    // const handleSubmit = () => {
    //     console.log('startDate ', selectedProduct);
    //     if (selectedProduct?.banner?.goodCode === '011') {
    //         getPAJAC020BusinessDate()
    //             .then(({ data }) => {
    //                 if (selectedProduct.banner.startDate == data.startDate && selectedProduct.banner.endDate == data.endDate) {
    //                     alert('동일 항목에 대해 타 사용자의 결제가 먼저 처리되어 본 요청은 진행되지 않았습니다. 재시도 해주시기 바랍니다.');
    //                     window.location.reload();
    //                 }
    //             })
    //             .catch(console.log);
    //     }
    // }

    const startSubmitting = () => {
        isSubmittingRef.current = true;
        setIsSubmitting(true);
    };

    const stopSubmitting = () => {
        isSubmittingRef.current = false;
        setIsSubmitting(false);
    };

    const handleSubmit = () => {
        // chặn double click: bỏ qua click thứ 2 khi lần submit trước chưa xử lý xong
        if (isSubmittingRef.current) {
            return;
        }
        startSubmitting();

        // Với tin tuyển dụng mới (!option), rSeq = id (seq của Recruit_Ready) là BẮT BUỘC.
        // Nếu vào route /pajac020 (không có :id) thì id = undefined -> returnUrl sẽ thành
        // rSeq=undefined -> backend không tìm thấy Recruit_Ready sau khi đã thanh toán.
        // Chặn tại đây để user không bị trừ tiền với đơn không hợp lệ.
        if (!option && (!id || isNaN(Number(id)))) {
            window.alert('존재하지 않는 링크입니다');
            navigate('/');
            stopSubmitting();
            return;
        }

        // if (selectedProduct?.banner?.goodCode === '011') {
        //     getPAJAC020BusinessDate()
        //         .then(({ data }) => {
        //             if (selectedProduct.banner.startDate == data.startDate && selectedProduct.banner.endDate == data.endDate) {
        //                 alert('동일 항목에 대해 타 사용자의 결제가 먼저 처리되어 본 요청은 진행되지 않았습니다. 재시도 해주시기 바랍니다.');
        //                 window.location.reload();
        //             }
        //         })
        //         .catch(console.log);
        // }

        // tracking thiết bị
        const deviceType = detectDevice();
        const isMobile = deviceType === 'android' || deviceType === 'ios';

        const totalPayloadCount = Object.values(payload).reduce((acc, list) => acc + list.length, 0);
        const totalPayloadTicketCount = Object.values(payloadTicket).reduce((acc, list) => acc + list.length, 0);
        // thanh toán hoàn toàn bằng ticket => không cần validate 결제자 정보
        const isFullTicketPay = totalPayloadTicketCount > 0 && totalPayloadCount === totalPayloadTicketCount;
        if (!isFullTicketPay && !validatePaymentDetails()) {
            stopSubmitting();
            return;
        }

        const vbankExpire = getVbankExpireAfterDays(3);
        const acceptMethodValue = `HPP(1):below1000:centerCd(Y):vbank(${vbankExpire})`;


        // có ticket nhưng không sử dụng
        for (const productKey in selectedProduct) {
            const product = selectedProduct[productKey];
            const ticketArray = payloadTicket[productKey];

            if (product && product.ticketNumber > 0 && ticketArray && ticketArray.length === 0) {
                if (
                    window.confirm(
                        '사용가능한 덴탈잡 이용권이 있습니다.\n적용하시려면 [확인] 버튼을 적용하지 않고 결제하시려면 [취소] 버튼을 선택하여 주세요.',
                    )
                ) {
                    stopSubmitting();
                    return;
                } else {
                    if (totalPay === 0) {
                        window.alert('상품을 선택해 주세요.');
                        stopSubmitting();
                        return;
                    }
                    const payFrom = document.querySelector('#payFrom');
                    if (payFrom) {
                        payFrom.remove();
                    }
                    postPayment({ totalPay })
                        .then(({ data }) => {
                            if (!window.INIStdPay) return alert('INIStdPay Loading Error');
                            const form = document.createElement('form');
                            form.id = 'payFrom';
                            form.method = 'POST';
                            document.body.appendChild(form);
                            let returnUrl;
                            if (!option) {
                                //New payment (Banner + Opt + Extra)
                                returnUrl = `${window.location.origin}/PAJAC020/payment-result?mSeq=${mSeq}&rSeq=${id}&goodCode=${goodCode}&receiptNum=${payloadReceipt.receiptNum}`;
                                if (isMobile) {
                                    returnUrl += `&device=mob&pEmail=${payloadReceipt?.email || ''}&pMobile=${payloadReceipt?.mobileNo || ''}`;
                                } else {
                                    returnUrl += `&device=pc`;
                                }
                                if (selectedProduct?.banner) {
                                    returnUrl += `&bannerStartDate=${selectedProduct.banner.startDate || moment(today).format('YYYY-MM-DD')
                                        }`;
                                }
                                if (selectedProduct?.fixed) {
                                    returnUrl += `&fixJumpUpStartDate=${selectedProduct.fixed.startDate || moment(today).format('YYYY-MM-DD')
                                        }`;
                                }
                                if (selectedProduct?.highlight) {
                                    returnUrl += `&extraGoodStartDate=${selectedProduct.highlight.startDate || moment(today).format('YYYY-MM-DD')
                                        }`;
                                }
                            } else {
                                //Addition payment (Opt + Extra)
                                returnUrl = `${window.location.origin}/PAJAC030/payment-result?mSeq=${mSeq}&rSeq=${id}&gCode=${goodCode}&receiptNum=${payloadReceipt.receiptNum}`;
                                if (isMobile) {
                                    returnUrl += `&device=mob&pEmail=${payloadReceipt?.email || ''}&pMobile=${payloadReceipt?.mobileNo || ''}`;
                                } else {
                                    returnUrl += `&device=pc`;
                                }

                                if (selectedProduct?.fixed) {
                                    returnUrl += `&optFrom=${selectedProduct.fixed.startDate || moment(today).format('YYYY-MM-DD')
                                        }&optEnd=${originalDate(selectedProduct.fixed)}`;
                                }
                                if (selectedProduct?.highlight) {
                                    returnUrl += `&extraFrom=${selectedProduct.highlight.startDate || moment(today).format('YYYY-MM-DD')
                                        }&extraEnd=${originalDate(selectedProduct.highlight)}`;
                                }
                            }
                            const closeUrl = `${window.location.origin}/payment-cancel`;
                            if (isMobile) {
                                const inputs = [
                                    { name: 'P_INI_PAYMENT', value: paymentMethod },
                                    { name: 'P_MID', value: data.mid },
                                    { name: 'P_OID', value: data.oid },
                                    { name: 'P_AMT', value: totalPay },
                                    { name: 'P_GOODS', value: `${goodName}` },
                                    { name: 'P_UNAME', value: `${payloadReceipt?.nameKor}` },
                                    { name: 'P_MOBILE', value: `${payloadReceipt?.mobileNo}` },
                                    { name: 'P_EMAIL', value: `${payloadReceipt?.email}` },
                                    { name: 'P_RESERVED', value: acceptMethodValue },
                                    { name: 'P_NEXT_URL', value: returnUrl },
                                    { name: 'P_NOTI_URL', value: 'https://api.dentaljob.co.kr/api/payment/vbank-callback' }
                                ];
                                inputs.forEach(({ name, value }) => {
                                    const input = document.createElement('input');
                                    input.type = 'hidden';
                                    input.name = name;
                                    input.value = value;
                                    form.appendChild(input);
                                    form.acceptCharset = 'EUC-KR';
                                    form.action = 'https://mobile.inicis.com/smart/payment/';
                                });
                                form.submit();
                            } else {
                                const inputs = [
                                    { name: 'version', value: '1.0' },
                                    { name: 'gopaymethod', value: paymentMethod },
                                    { name: 'mid', value: data.mid },
                                    { name: 'oid', value: data.oid },
                                    { name: 'price', value: totalPay },
                                    { name: 'timestamp', value: data.timestamp },
                                    { name: 'use_chkfake', value: 'Y' },
                                    { name: 'signature', value: data.signature },
                                    { name: 'verification', value: data.verification },
                                    { name: 'mKey', value: data.mKey },
                                    { name: 'currency', value: 'WON' },
                                    { name: 'goodname', value: `${goodName}` },
                                    { name: 'buyername', value: `${payloadReceipt?.nameKor}` },
                                    { name: 'buyertel', value: `${payloadReceipt?.mobileNo}` },
                                    { name: 'buyeremail', value: `${payloadReceipt?.email}` },
                                    { name: 'acceptmethod', value: acceptMethodValue },
                                    { name: 'returnUrl', value: returnUrl },
                                    { name: 'closeUrl', value: closeUrl },
                                ];
                                inputs.forEach(({ name, value }) => {
                                    const input = document.createElement('input');
                                    input.type = 'hidden';
                                    input.name = name;
                                    input.value = value;
                                    form.appendChild(input);
                                });
                                window.INIStdPay.pay('payFrom');
                            }
                        })
                        .catch((error) => console.log(error))
                        .finally(stopSubmitting);
                }
            }
        }

        // thanh toán bằng ticket && bình thường
        if (totalPayloadTicketCount > 0 && totalPayloadCount !== totalPayloadTicketCount) {
            const payFrom = document.querySelector('#payFrom');
            if (payFrom) {
                payFrom.remove();
            }
            postPayment({ totalPay })
                .then(({ data }) => {
                    if (!window.INIStdPay) return alert('INIStdPay Loading Error');
                    const form = document.createElement('form');
                    form.id = 'payFrom';
                    form.method = 'POST';
                    document.body.appendChild(form);
                    let returnUrl;
                    if (!option) {
                        returnUrl = `${window.location.origin
                            }/PAJAC020/payment-result?mSeq=${mSeq}&rSeq=${id}&receiptNum=${payloadReceipt?.receiptNum || ''
                            }`;
                        if (isMobile) {
                            returnUrl += `&device=mob&pEmail=${payloadReceipt?.email || ''}&pMobile=${payloadReceipt?.mobileNo || ''}`;
                        } else {
                            returnUrl += `&device=pc`;
                        }
                        returnUrl += `&goodCode=${Object.values(processBannerData(selectedProduct).payment)
                            .map((item) => item.goodCode)
                            .join(',') || ''
                            }`;
                        returnUrl += `&goodCodeTicket=${Object.values(processBannerData(selectedProduct).ticket)
                            .map((item) => item.goodCode)
                            .join(',') || ''
                            }`;
                        returnUrl += `&ticketSeq=${Object.values(processBannerData(selectedProduct).ticket)
                            .map((item) => item.ticketSeqToUse)
                            .join(',') || ''
                            }`;

                        if (selectedProduct?.banner) {
                            returnUrl += `&bannerStartDate=${selectedProduct.banner.startDate || moment(today).format('YYYY-MM-DD')
                                }`;
                        }
                        if (selectedProduct?.fixed) {
                            returnUrl += `&fixJumpUpStartDate=${selectedProduct.fixed.startDate || moment(today).format('YYYY-MM-DD')
                                }`;
                        }
                        if (selectedProduct?.highlight) {
                            returnUrl += `&extraGoodStartDate=${selectedProduct.highlight.startDate || moment(today).format('YYYY-MM-DD')
                                }`;
                        }
                    } else {
                        returnUrl = `${window.location.origin}/PAJAC030/payment-result?mSeq=${mSeq}&rSeq=${id}&receiptNum=${payloadReceipt?.receiptNum || ''
                            }`;
                        returnUrl += `&gCode=${Object.values(processBannerData(selectedProduct).payment)
                            .map((item) => item.goodCode)
                            .join(',') || ''
                            }`;
                        if (isMobile) {
                            returnUrl += `&device=mob&pEmail=${payloadReceipt?.email || ''}&pMobile=${payloadReceipt?.mobileNo || ''}`;
                        } else {
                            returnUrl += `&device=pc`;
                        }
                        returnUrl += `&ticketSeq=${Object.values(processBannerData(selectedProduct).ticket)
                            .map((item) => item.ticketSeqToUse)
                            .join(',') || ''
                            }`;
                        returnUrl += `&gCodeTicket=${Object.values(processBannerData(selectedProduct).ticket)
                            .map((item) => item.goodCode)
                            .join(',') || ''
                            }`;

                        if (payloadTicket.fixed.length > 0) {
                            returnUrl += `&optFromTicket=${selectedProduct.fixed.startDate || moment(today).format('YYYY-MM-DD')
                                }&optEndTicket=${originalDate(selectedProduct.fixed)}`;
                        }
                        if (payloadTicket.highlight.length > 0) {
                            returnUrl += `&extraFromTicket=${selectedProduct.highlight.startDate || moment(today).format('YYYY-MM-DD')
                                }&extraEndTicket=${originalDate(selectedProduct.highlight)}`;
                        }

                        if (payload.fixed.length > 0 && payloadTicket.fixed.length === 0) {
                            returnUrl += `&optFrom=${selectedProduct.fixed.startDate || moment(today).format('YYYY-MM-DD')
                                }&optEnd=${originalDate(selectedProduct.fixed)}`;
                        }

                        if (payload.highlight.length > 0 && payloadTicket.highlight.length === 0) {
                            returnUrl += `&extraFrom=${selectedProduct.highlight.startDate || moment(today).format('YYYY-MM-DD')
                                }&extraEnd=${originalDate(selectedProduct.highlight)}`;
                        }
                    }
                    const closeUrl = `${window.location.origin}/payment-cancel`;

                    if (isMobile) {
                        const inputs = [
                            { name: 'P_INI_PAYMENT', value: paymentMethod },
                            { name: 'P_MID', value: data.mid },
                            { name: 'P_OID', value: data.oid },
                            { name: 'P_AMT', value: totalPay },
                            { name: 'P_GOODS', value: `${goodName}` },
                            { name: 'P_UNAME', value: `${payloadReceipt?.nameKor}` },
                            { name: 'P_MOBILE', value: `${payloadReceipt?.mobileNo}` },
                            { name: 'P_EMAIL', value: `${payloadReceipt?.email}` },
                            { name: 'P_RESERVED', value: acceptMethodValue },
                            { name: 'P_NEXT_URL', value: returnUrl },
                            { name: 'P_NOTI_URL', value: 'https://api.dentaljob.co.kr/api/payment/vbank-callback' },
                            { name: 'P_CHARSET', value: 'utf8' }
                        ];
                        inputs.forEach(({ name, value }) => {
                            const input = document.createElement('input');
                            input.type = 'hidden';
                            input.name = name;
                            input.value = value;
                            form.appendChild(input);
                            form.acceptCharset = 'EUC-KR';
                            form.action = 'https://mobile.inicis.com/smart/payment/';
                        });
                        form.submit();
                    } else {

                        const inputs = [
                            { name: 'version', value: '1.0' },
                            { name: 'gopaymethod', value: paymentMethod }, //빈값으로 세팅 시, 전체 결제수단 표시
                            { name: 'mid', value: data.mid },
                            { name: 'oid', value: data.oid },
                            { name: 'price', value: totalPay },
                            { name: 'timestamp', value: data.timestamp },
                            { name: 'use_chkfake', value: 'Y' },
                            { name: 'signature', value: data.signature },
                            { name: 'verification', value: data.verification },
                            { name: 'mKey', value: data.mKey },
                            { name: 'currency', value: 'WON' },
                            { name: 'goodname', value: `${goodName}` },
                            { name: 'buyername', value: `${payloadReceipt?.nameKor}` },
                            { name: 'buyertel', value: `${payloadReceipt?.mobileNo}` },
                            { name: 'buyeremail', value: `${payloadReceipt?.email}` },
                            { name: 'acceptmethod', value: acceptMethodValue },
                            { name: 'returnUrl', value: returnUrl },
                            { name: 'closeUrl', value: closeUrl },
                        ];
                        inputs.forEach(({ name, value }) => {
                            const input = document.createElement('input');
                            input.type = 'hidden';
                            input.name = name;
                            input.value = value;
                            form.appendChild(input);
                        });
                        window.INIStdPay.pay('payFrom');
                    }
                })
                .catch((error) => console.log(error))
                .finally(stopSubmitting);
        }
        if (!option && !selectedProduct.banner) {
            alert('기본상품을 선택해 주세요.');
            stopSubmitting();
            return;
        }

        // thanh toán bằng ticket
        if (totalPayloadTicketCount > 0 && totalPayloadCount === totalPayloadTicketCount && !option) {
            postPAJAC020PaymentTicket({
                seq: id,
                goodName,
                goodNameCode: goodCode,
                ticketSeq,
                bannerStartDate: selectedProduct?.banner?.goodCode
                    ? selectedProduct?.banner?.startDate || moment(today).format('YYYY-MM-DD')
                    : '',
                fixJumpUpStartDate: selectedProduct.fixed
                    ? selectedProduct?.fixed?.startDate || moment(today).format('YYYY-MM-DD')
                    : '',
                extraGoodStartDate: selectedProduct.highlight
                    ? selectedProduct?.highlight?.startDate || moment(today).format('YYYY-MM-DD')
                    : '',
                receiptNum: payloadReceipt?.receiptNum,
                buyerEmail: payloadReceipt?.email,
                buyerTel: payloadReceipt?.mobileNo,
                buyerName: payloadReceipt?.nameKor,
            })
                .then(({ data }) => {
                    updateUserData({ seq: id, rc: data.rc, pm: data.pm });
                })
                .catch((error) => console.log(error))
                .finally(stopSubmitting);
        }

        // thanh toán bằng ticket và thêm option = true
        if (totalPayloadTicketCount > 0 && totalPayloadCount === totalPayloadTicketCount && option) {
            postPAJAC030PaymentTicket({
                seq: id,
                goodName,
                goodNameCode: goodCode,
                ticketSeq,
                optFrom: selectedProduct?.fixed
                    ? selectedProduct?.fixed?.startDate || moment(today).format('YYYY-MM-DD')
                    : '',
                optEnd: selectedProduct?.fixed ? originalDate(selectedProduct?.fixed) : '',
                extraFrom: selectedProduct?.highlight
                    ? selectedProduct?.highlight?.startDate || moment(today).format('YYYY-MM-DD')
                    : '',
                extraEnd: selectedProduct?.highlight ? originalDate(selectedProduct?.highlight) : '',
                extraTerm: selectedProduct?.highlight
                    ? `${selectedProduct?.highlight?.goodCode}|${selectedProduct?.highlight?.startDate || moment(today).format('YYYY-MM-DD')
                    }|${originalDate(selectedProduct?.highlight)}`
                    : '',
                receiptNum: payloadReceipt?.receiptNum,
                buyerEmail: payloadReceipt?.email,
                buyerTel: payloadReceipt?.mobileNo,
                receiptName: payloadReceipt?.nameKor,
            })
                .then(({ data }) => {
                    updateUserData({ rc: id, pm: data });
                })
                .catch((error) => console.log(error))
                .finally(stopSubmitting);
        }

        // thanh toán bình thường
        else if (totalPayloadTicketCount === 0) {
            if (totalPay === 0) {
                window.alert('상품을 선택해 주세요.');
                stopSubmitting();
                return;
            }
            const payFrom = document.querySelector('#payFrom');
            if (payFrom) {
                payFrom.remove();
            }
            postPayment({ totalPay })
                .then(({ data }) => {
                    if (!window.INIStdPay) return alert('INIStdPay Loading Error');
                    const form = document.createElement('form');
                    form.id = 'payFrom';
                    form.method = 'POST';
                    document.body.appendChild(form);
                    let returnUrl;
                    if (!option) {
                        //New payment (Banner + Opt + Extra)
                        returnUrl = `${window.location.origin
                            }/PAJAC020/payment-result?mSeq=${mSeq}&rSeq=${id}&goodCode=${goodCode}&receiptNum=${payloadReceipt?.receiptNum || ''
                            }`;
                        if (isMobile) {
                            returnUrl += `&device=mob&pEmail=${payloadReceipt?.email || ''}&pMobile=${payloadReceipt?.mobileNo || ''}`;
                        } else {
                            returnUrl += `&device=pc`;
                        }
                        if (selectedProduct?.banner) {
                            returnUrl += `&bannerStartDate=${selectedProduct.banner.startDate || moment(today).format('YYYY-MM-DD')
                                }`;
                        }
                        if (selectedProduct?.fixed) {
                            returnUrl += `&fixJumpUpStartDate=${selectedProduct.fixed.startDate || moment(today).format('YYYY-MM-DD')
                                }`;
                        }
                        if (selectedProduct?.highlight) {
                            returnUrl += `&extraGoodStartDate=${selectedProduct.highlight.startDate || moment(today).format('YYYY-MM-DD')
                                }`;
                        }
                    } else {
                        //Additional Payment (Opt + Extra)
                        returnUrl = `${window.location.origin}/PAJAC030/payment-result?mSeq=${mSeq}&rSeq=${id}&gCode=${goodCode}&receiptNum=${payloadReceipt?.receiptNum || ''
                            }`;
                        if (isMobile) {
                            returnUrl += `&device=mob&pEmail=${payloadReceipt?.email || ''}&pMobile=${payloadReceipt?.mobileNo || ''}`;
                        } else {
                            returnUrl += `&device=pc`;
                        }
                        if (selectedProduct?.fixed) {
                            returnUrl += `&optFrom=${selectedProduct.fixed.startDate || moment(today).format('YYYY-MM-DD')
                                }&optEnd=${originalDate(selectedProduct.fixed)}`;
                        }
                        if (selectedProduct?.highlight) {
                            returnUrl += `&extraFrom=${selectedProduct.highlight.startDate || moment(today).format('YYYY-MM-DD')
                                }&extraEnd=${originalDate(selectedProduct.highlight)}`;
                        }
                    }
                    const closeUrl = `${window.location.origin}/payment-cancel`;
                    if (isMobile) {
                        const inputs = [
                            { name: 'P_INI_PAYMENT', value: paymentMethod },
                            { name: 'P_MID', value: data.mid },
                            { name: 'P_OID', value: data.oid },
                            { name: 'P_AMT', value: totalPay },
                            { name: 'P_GOODS', value: `${goodName}` },
                            { name: 'P_UNAME', value: `${payloadReceipt?.nameKor}` },
                            { name: 'P_MOBILE', value: `${payloadReceipt?.mobileNo}` },
                            { name: 'P_EMAIL', value: `${payloadReceipt?.email}` },
                            { name: 'P_RESERVED', value: acceptMethodValue },
                            { name: 'P_NEXT_URL', value: returnUrl },
                            { name: 'P_NOTI_URL', value: 'https://api.dentaljob.co.kr/api/payment/vbank-callback' },
                            { name: 'P_CHARSET', value: 'utf8' }
                        ];
                        inputs.forEach(({ name, value }) => {
                            const input = document.createElement('input');
                            input.type = 'hidden';
                            input.name = name;
                            input.value = value;
                            form.appendChild(input);
                            form.acceptCharset = 'EUC-KR';
                            form.action = 'https://mobile.inicis.com/smart/payment/';
                        });
                        form.submit();
                    } else {
                        const inputs = [
                            { name: 'version', value: '1.0' },
                            { name: 'gopaymethod', value: paymentMethod }, //빈값으로 세팅 시, 전체 결제수단 표시
                            { name: 'mid', value: data.mid },
                            { name: 'oid', value: data.oid },
                            { name: 'price', value: totalPay },
                            { name: 'timestamp', value: data.timestamp },
                            { name: 'use_chkfake', value: 'Y' },
                            { name: 'signature', value: data.signature },
                            { name: 'verification', value: data.verification },
                            { name: 'mKey', value: data.mKey },
                            { name: 'currency', value: 'WON' },
                            { name: 'goodname', value: `${goodName}` },
                            { name: 'buyername', value: `${payloadReceipt?.nameKor}` },
                            { name: 'buyertel', value: `${payloadReceipt?.mobileNo}` },
                            { name: 'buyeremail', value: `${payloadReceipt?.email}` },
                            { name: 'acceptmethod', value: acceptMethodValue },
                            { name: 'returnUrl', value: returnUrl },
                            { name: 'closeUrl', value: closeUrl },
                        ];
                        inputs.forEach(({ name, value }) => {
                            const input = document.createElement('input');
                            input.type = 'hidden';
                            input.name = name;
                            input.value = value;
                            form.appendChild(input);
                        });
                        window.INIStdPay.pay('payFrom');
                    }
                })
                .catch((error) => console.log(error))
                .finally(stopSubmitting);
        }
    };

    return (
        <>
            <div className="pym">
                <div className="pym__container">
                    <div className="pym__top">
                        <div className="pym__lf">
                            <div className="pym__hean">광고상품 소개</div>
                            <div className="pym__desc">
                                각 광고상품의 노출위치, 적용 방법, 예시 이미지 등에 대해 소개하오니,
                                <br />
                                광고 신청 전 자세히 확인 후 신청을 부탁드립니다.
                            </div>
                        </div>
                        <button
                            type="button"
                            className="pym__guide"
                            onClick={() => {
                                window.open('/pahab010');
                            }}
                        >
                            광고상품 안내
                        </button>
                    </div>
                    <h4 className="pym__tit">광고상품 선택 및 [덴탈잡 이용권] 적용 </h4>
                    <table className="pym__table">
                        <thead>
                            <tr>
                                <th rowSpan={2} style={{ width: '140px' }}>
                                    구분
                                </th>
                                <th rowSpan={2} colSpan={2}>
                                    상품
                                </th>
                                <th rowSpan={2} style={{ width: '70px' }}>
                                    기간
                                </th>
                                <th rowSpan={2}>금액</th>
                                <th colSpan={2} className="relative">
                                    [덴탈잡 이용권]
                                    <img
                                        src="./images/icons/icon-info-th.png"
                                        alt="icon icon-tlt"
                                        className="icon-tlt"
                                    />
                                    <div className="tlt">
                                        DVmall에서 [덴탈잡 이용권]을 구매할 수<br /> 있으며, 비용이 더욱 저렴합니다.
                                        <svg
                                            className="tlt__svg"
                                            width={28}
                                            height={16}
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                        >
                                            <polyline
                                                points="18 16 0 8 18 0"
                                                strokeWidth={1}
                                                stroke="#88abda"
                                                fill="#e6effa"
                                                paintOrder="fill"
                                            />
                                            <rect x={18} y={0} width={10} height={16} fill="#e6effa" />
                                        </svg>
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th>보유현황</th>
                                <th>적용</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!option && appGbnCd !== '999' && (
                                <>
                                    <tr>
                                        <th rowSpan={9}>
                                            기본상품 &amp;
                                            <br />
                                            배너고정옵션
                                        </th>
                                    </tr>
                                    {renderBannerRows(false)}
                                </>
                            )}

                            {!option && appGbnCd == '999' && (
                                <>
                                    <tr>
                                        <th rowSpan={3}>
                                            기본상품 &amp;
                                            <br />
                                            배너고정옵션
                                        </th>
                                    </tr>
                                    {renderBannerRows(true)}
                                </>
                            )}
                            {/* // Banner */}
                            {/* fixed */}
                            {appGbnCd !== '999' && (
                                <>
                                    <tr>
                                        <th className="pd5">
                                            고정옵션 &amp;
                                            <br />
                                            (채용정보 page)
                                        </th>
                                        <td className="center">
                                            <input
                                                type="checkbox"
                                                className="rgst__checkbox"
                                                name="fixed"
                                                value={productData.fixed[0].selectedGoodCode}
                                                checked={payload.fixed.includes(productData.fixed[0].selectedGoodCode)}
                                                onChange={() => handleCheckboxChange('fixed', productData.fixed[0])}
                                            />
                                        </td>
                                        <td>{productData.fixed[0].name}</td>
                                        <td className="center">{productData.fixed[0].duration}일</td>
                                        {/* <td className="pd9 center">
                                            {productData.fixed[0].settingDuration ? (
                                                <Dropdown
                                                    placeholder={productData.fixed[0].duration + '일' || '7일'}
                                                    options={[
                                                        { option: '7일', value: '7' },
                                                        { option: '14일', value: '14' },
                                                    ]}
                                                    name={`duration_fixed_${productData.fixed[0].selectedGoodCode}`}
                                                    onChange={handleChangeDuration}
                                                />
                                            ) : (
                                                `${productData.fixed[0].duration}일`
                                            )}
                                        </td> */}
                                        <td className="text-end">
                                            {formatNumberWithCommas(productData.fixed[0].selectedPrice)}원
                                        </td>
                                        <td className={`center ${productData.fixed[0].selectedTicketNumber > 0 ? 'blue' : ''}`}>
                                            {productData.fixed[0].selectedTicketNumber}개
                                        </td>
                                        <td className="center">
                                            <input
                                                type="checkbox"
                                                className="rgst__checkbox"
                                                value={productData.fixed[0].selectedTicket}
                                                checked={payloadTicket.fixed.includes(productData.fixed[0].selectedTicket)}
                                                disabled={isTicketDisabled('fixed', productData.fixed[0].selectedTicket)}
                                                onChange={() => handleApplyTicket('fixed', productData.fixed[0].selectedTicket)}
                                            />
                                        </td>
                                    </tr>
                                    {/* // fixed */}
                                    {/* highlight */}
                                    <tr>
                                        <th rowSpan={9}>
                                            강조옵션
                                            <br />
                                            (채용정보 page)
                                        </th>
                                    </tr>
                                    {productData.highlight.slice(0, 4).map((item, index) => (
                                        <tr key={'hightlight' + index}>
                                            <td className="center">
                                                <input
                                                    type="checkbox"
                                                    className="rgst__checkbox"
                                                    name="highlight"
                                                    value={item.goodCode}
                                                    checked={payload.highlight.includes(item.goodCode)}
                                                    onChange={() => handleCheckboxChange('highlight', item)}
                                                />
                                            </td>
                                            <td>{item.name}</td>
                                            <td className="center">{item.duration}일</td>
                                            <td className="text-end">{formatNumberWithCommas(item.price)}원</td>
                                            <td className={`center ${item.ticketNumber > 0 ? 'blue' : ''}`}>
                                                {item.ticketNumber}개
                                            </td>
                                            <td className="center">
                                                <input
                                                    type="checkbox"
                                                    className="rgst__checkbox"
                                                    value={item.ticketCode}
                                                    checked={payloadTicket.highlight.includes(item.ticketCode)}
                                                    disabled={isTicketDisabled('highlight', item.goodCode)}
                                                    onChange={() => handleApplyTicket('highlight', item.ticketCode)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td className="center">
                                            <input
                                                type="checkbox"
                                                className="rgst__checkbox"
                                                name="highlight"
                                                value={productData.highlight[4].goodCode}
                                                checked={payload.highlight.includes(productData.highlight[4].goodCode)}
                                                onChange={() => handleCheckboxChange('highlight', productData.highlight[4])}
                                            />
                                        </td>
                                        <td>{productData.highlight[4].name}</td>
                                        <td rowSpan={2} className="center">
                                            {productData.highlight[4].duration}일
                                        </td>
                                        <td rowSpan={2} className="text-end">
                                            {formatNumberWithCommas(productData.highlight[4].price)}원
                                        </td>
                                        <td
                                            rowSpan={2}
                                            className={`center ${productData.highlight[4].ticketNumber > 0 ? 'blue' : ''}`}
                                        >
                                            {productData.highlight[4].ticketNumber}개
                                        </td>
                                        <td rowSpan={2} className="center">
                                            <input
                                                type="checkbox"
                                                className="rgst__checkbox"
                                                value={productData.highlight[4].ticketCode}
                                                checked={
                                                    (payload.highlight.includes(productData.highlight[4].goodCode) ||
                                                        payload.highlight.includes(productData.highlight[5].goodCode)) &&
                                                    productData.highlight[4].ticketNumber > 0
                                                }
                                                disabled={isTicketDisabled('highlight', productData.highlight[4].ticketCode)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="center">
                                            <input
                                                type="checkbox"
                                                className="rgst__checkbox"
                                                name="highlight"
                                                value={productData.highlight[5].goodCode}
                                                checked={payload.highlight.includes(productData.highlight[5].goodCode)}
                                                onChange={() => handleCheckboxChange('highlight', productData.highlight[5])}
                                            />
                                        </td>
                                        <td>{productData.highlight[5].name}</td>
                                    </tr>
                                    <tr>
                                        <td className="center">
                                            <input
                                                type="checkbox"
                                                className="rgst__checkbox"
                                                name="highlight"
                                                value={productData.highlight[6].goodCode}
                                                checked={payload.highlight.includes(productData.highlight[6].goodCode)}
                                                onChange={() => handleCheckboxChange('highlight', productData.highlight[6])}
                                            />
                                        </td>
                                        <td>{productData.highlight[6].name}</td>
                                        <td rowSpan={2} className="center">
                                            {productData.highlight[6].duration}일
                                        </td>
                                        <td rowSpan={2} className="text-end">
                                            {formatNumberWithCommas(productData.highlight[6].price)}원
                                        </td>
                                        <td
                                            rowSpan={2}
                                            className={`center ${productData.highlight[6].ticketNumber > 0 ? 'blue' : ''}`}
                                        >
                                            {productData.highlight[6].ticketNumber}개
                                        </td>
                                        <td rowSpan={2} className="center">
                                            <input
                                                type="checkbox"
                                                className="rgst__checkbox"
                                                value={productData.highlight[6].ticketCode}
                                                checked={
                                                    (payload.highlight.includes(productData.highlight[6].goodCode) ||
                                                        payload.highlight.includes(productData.highlight[7].goodCode)) &&
                                                    productData.highlight[6].ticketNumber > 0
                                                }
                                                disabled={isTicketDisabled('highlight', productData.highlight[6].ticketCode)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="center">
                                            <input
                                                type="checkbox"
                                                className="rgst__checkbox"
                                                name="highlight"
                                                value={productData.highlight[7].goodCode}
                                                checked={payload.highlight.includes(productData.highlight[7].goodCode)}
                                                onChange={() => handleCheckboxChange('highlight', productData.highlight[7])}
                                            />
                                        </td>
                                        <td>{productData.highlight[7].name}</td>
                                    </tr>
                                </>
                            )}
                            {/* highlight */}
                        </tbody>
                    </table>

                    <div className="pym__wrap">
                        <ul className="pym__list">
                            <li className="pym__item">
                                모든 상품은 1회 비용이며, 서비스 기간 중간에 채용마감을 하시면 남은 기간은 소멸됩니다.
                            </li>
                            <li className="pym__item">
                                상품 신청일과 결제일이 동일한 일자일 경우 신청일자부터 공고 1일 째가 됩니다.
                            </li>
                            <li className="pym__item">
                                옵션 및 강조 상품은 해당 공고 기간 내에서만 서비스가 가능하며, 공고 종료일을 초과할 수
                                없습니다.
                            </li>
                            <li className="pym__item">
                                온라인 상품의 특성상 한번 게재되면 상품을 사용하신 것으로 간주되어 환불이 어려우니,
                                신중하게 신청해주시면 감사하겠습니다.
                            </li>
                            <li className="pym__item" style={{ color: 'red' }}>
                                DVmall 멤버십 가입하고 덴탈잡 이용권을 10% 더 저렴하게 이용하세요.
                            </li>
                        </ul>
                        <div className="pym__btbx">
                            <a
                                href="https://www.dvmall.co.kr/search-result?query=%EB%8D%B4%ED%83%88%EC%9E%A1"
                                className="pym__btn"
                                target="_blank"
                                rel="noreferrer"
                            >
                                DVmall에서<br />[덴탈잡 이용권] 구매
                            </a>

                            <a
                                href="https://www.dvmall.co.kr/product-list?cat=A3040301"
                                className="pym__btn"
                                target="_blank"
                                rel="noreferrer"
                            >
                                DVmall에서<br />[멤버십] 가입
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="byn">
                <div className="byn__container">
                    <div className="byn__block">
                        <div className="byn__tit">광고 기간 설정</div>
                        {option && (
                            <div
                                className="byn__note"
                                style={{ marginBottom: '15px', textAlign: 'center', gap: '5px' }}
                            >
                                <p>
                                    현재 진행중인 채용광고의 기간은{' '}
                                    <span className="byn__tdate">
                                        {recruitFrom} ~ {recruitEnd}
                                    </span>{' '}
                                    입니다.
                                </p>
                                <p>
                                    추가하시는 강조 및 옵션상품의 기간은 최대{' '}
                                    <span className="byn__tdate">{recruitEnd}</span> 까지만 가능합니다.
                                </p>
                                <p>
                                    강조 및 옵션상품은 상품특성상 진행중인 채용광고의 기간중에만 가능한 사용가능한
                                    상품으로
                                </p>
                                <p>
                                    채용광고 시작일 (<span className="byn__tdate">{recruitFrom}</span>) 까지
                                    결제(입금)가 완료되어야 게재가 가능합니다.
                                </p>
                            </div>
                        )}
                        <table className="byn__table">
                            <thead>
                                <tr>
                                    <th>구분</th>
                                    <th style={{ minWidth: '230px' }}>선택한 상품</th>
                                    <th>기간</th>
                                    <th>
                                        <span className="byn__req">*</span>광고기간
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {payload.banner.length > 0 && (
                                    <>
                                        <tr>
                                            <td rowSpan={2} data-label="구분" className="byn__title">
                                                <span className="byn__title">기본상품</span>
                                            </td>
                                            <td data-label="선택한 상품">
                                                <span className="byn__name">{selectedProduct?.banner?.name}</span>
                                            </td>
                                            <td className="byn__duration center" data-label="기간">
                                                <span>{selectedProduct?.banner?.duration}일</span>
                                            </td>
                                            <td data-label="*광고기간">
                                                <div className="byn__wdate">
                                                    <span className="byn__txt">시작일자</span>
                                                    <div className="byn_date">
                                                        <DatePicker
                                                            ref={startDateRefBanner}
                                                            locale={'ko'}
                                                            placeholderText={'YYYY/MM/DD'}
                                                            dateFormat={'yyyy/MM/dd'}

                                                            minDate={businessMin ?? today.toDate()}
                                                            selected={businessStart ?? today.toDate()}
                                                            maxDate={businessEnd ?? ''}

                                                            onChange={(date) =>
                                                                handleDateChange(
                                                                    'banner',
                                                                    moment(date).format('YYYY-MM-DD'),
                                                                )
                                                            }
                                                        />
                                                        <i
                                                            className="icon icon-date"
                                                            id="start-date-icon"
                                                            onClick={() => startDateRefBanner.current.setFocus()}
                                                        />
                                                    </div>
                                                    <div className="byn__wrap-note">
                                                        <span className="byn__txt">- 종료일자:</span>
                                                        <span className="byn__tdate">
                                                            {selectedProduct?.banner?.endDate
                                                                ? selectedProduct?.banner?.endDate
                                                                : originalDate(selectedProduct?.banner)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3} className="byn__tdnote">
                                                ※ 배너상품을 선택하신 경우 시작일자 및 종료일자는 배너상품에 추가되어
                                                있는 채용정보광고의 기간입니다.
                                                <br />
                                                ※ 배너상품의 게재기간은 채용정보광고의 시작일로부터 7일간 서비스됩니다.
                                                <br />
                                                <span>
                                                    ※ 비즈니스 배너의 예약이 많은 경우 날짜 선택의 제한이 있을 수 있으며, 게재 가능한 날짜 기준 일주일 까지만 날짜 선택이 가능합니다.
                                                </span>
                                            </td>
                                        </tr>
                                    </>
                                )}
                                {payload.bannerOp.length > 0 && (
                                    <tr>
                                        <td data-label="구분">
                                            <span className="byn__title">배너고정옵션</span>
                                        </td>
                                        <td data-label="선택한 상품">
                                            <span className="byn__name">{selectedProduct?.bannerOp?.name}</span>
                                        </td>
                                        <td className="byn__duration center" data-label="기간">
                                            <span>{selectedProduct?.bannerOp?.duration}일</span>
                                        </td>
                                        <td data-label="광고기간">※ 옵션상품일자는 배너시작일부터 7일간입니다.</td>
                                    </tr>
                                )}
                                {payload.fixed.length > 0 && (
                                    <tr>
                                        <td data-label="구분">
                                            <span className="byn__title">고정옵션</span>
                                        </td>
                                        <td data-label="선택한 상품">
                                            <span className="byn__name">{selectedProduct?.fixed?.name}</span>
                                        </td>
                                        <td className="center" data-label="기간">
                                            {selectedProduct?.fixed?.duration}일
                                        </td>
                                        <td data-label="광고기간">
                                            <div className="byn__wdate">
                                                <span className="byn__txt">시작일자</span>
                                                <div className="byn_date">
                                                    <DatePicker
                                                        ref={startDateRefFixed}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={(() => {
                                                            if (
                                                                selectedProduct?.fixed?.startDate &&
                                                                selectedProduct?.banner?.startDate &&
                                                                moment(
                                                                    selectedProduct.fixed.startDate,
                                                                    'YYYY-MM-DD',
                                                                ).isBefore(
                                                                    moment(
                                                                        selectedProduct.banner.startDate,
                                                                        'YYYY-MM-DD',
                                                                    ),
                                                                )
                                                            ) {
                                                                selectedProduct.fixed.startDate =
                                                                    selectedProduct.banner.startDate;
                                                            }
                                                            return selectedProduct?.fixed?.startDate
                                                                ? moment(
                                                                    selectedProduct.fixed.startDate,
                                                                    'YYYY-MM-DD',
                                                                ).toDate()
                                                                : selectedProduct?.banner?.startDate;
                                                        })()}
                                                        onChange={(date) =>
                                                            handleDateChange('fixed', moment(date).format('YYYY-MM-DD'))
                                                        }
                                                        minDate={selectedProduct?.banner?.startDate}
                                                        maxDate={moment(recruitEnd, 'YYYY-MM-DD').toDate()}
                                                    />

                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => {
                                                            if (startDateRefFixed.current) {
                                                                startDateRefFixed.current.setFocus();
                                                            } else {
                                                                console.error('startDateRefFixed.current is null');
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="byn__wrap-note">
                                                    <span className="byn__txt">- 종료일자:</span>
                                                    <span className="byn__tdate">
                                                        {selectedProduct?.fixed?.endDate
                                                            ? selectedProduct?.fixed?.endDate
                                                            : originalDate(selectedProduct?.fixed)}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                {payload.highlight.length > 0 && (
                                    <tr>
                                        <td data-label="구분">
                                            <span className="byn__title">강조옵션</span>
                                        </td>
                                        <td data-label="선택한 상품">
                                            <span className="byn__name">{selectedProduct?.highlight?.name}</span>
                                        </td>
                                        <td className="center" data-label="기간">
                                            {selectedProduct?.highlight?.duration}일
                                        </td>
                                        <td data-label="광고기간">
                                            <div className="byn__wdate">
                                                <span className="byn__txt">시작일자</span>
                                                <div className="byn_date">
                                                    <DatePicker
                                                        ref={startDateRefHighlight}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={(() => {
                                                            if (
                                                                selectedProduct?.highlight?.startDate &&
                                                                selectedProduct?.banner?.startDate &&
                                                                moment(
                                                                    selectedProduct.highlight.startDate,
                                                                    'YYYY-MM-DD',
                                                                ).isBefore(
                                                                    moment(
                                                                        selectedProduct.banner.startDate,
                                                                        'YYYY-MM-DD',
                                                                    ),
                                                                )
                                                            ) {
                                                                selectedProduct.highlight.startDate =
                                                                    selectedProduct.banner.startDate;
                                                            }
                                                            return selectedProduct?.highlight?.startDate
                                                                ? moment(
                                                                    selectedProduct.highlight.startDate,
                                                                    'YYYY-MM-DD',
                                                                ).toDate()
                                                                : selectedProduct?.banner?.startDate;
                                                        })()}
                                                        onChange={(date) =>
                                                            handleDateChange(
                                                                'highlight',
                                                                moment(date).format('YYYY-MM-DD'),
                                                            )
                                                        }
                                                        minDate={selectedProduct?.banner?.startDate}
                                                        maxDate={moment(recruitEnd, 'YYYY-MM-DD').toDate()}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => {
                                                            if (startDateRefHighlight.current) {
                                                                startDateRefHighlight.current.setFocus();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="byn__wrap-note">
                                                    <span className="byn__txt">- 종료일자:</span>
                                                    <span className="byn__tdate">
                                                        {selectedProduct?.highlight?.endDate
                                                            ? selectedProduct?.highlight?.endDate
                                                            : originalDate(selectedProduct?.highlight)}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="byn__note">
                            <b>*안내사항</b>
                            <p>
                                ※ 상기 상품은 기간에 관계없이 1회 신청비용이며, 서비스 기간 중간에 채용광고를 마감하시면
                                남은 기간은 소멸됩니다.
                            </p>
                            <p>
                                ※ 옵션 및 강조 상품은 채용광고 기간내에서만 서비스가 가능하며, 채용광고 종료일을 초과할
                                수 없습니다.
                            </p>
                            <p>
                                ※ 온라인 상품의 특성상 한번 게재되면 상품 사용으로 간주되오니, 많은 양해 부탁드립니다.
                            </p>
                        </div>
                    </div>
                    <div className="byn__block">
                        <div className="byn__tit">결제금액 확인</div>
                        <table className="byn__table byn__table2">
                            <thead>
                                <tr>
                                    <th>구분</th>
                                    <th>결제상품</th>
                                    <th>덴탈잡 이용권 적용</th>
                                    <th>금액</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedProduct?.banner && (
                                    <tr>
                                        <td data-label="구분" style={{ textAlign: 'center' }}>
                                            {selectedProduct?.banner?.duration}일
                                        </td>
                                        <td data-label="결제상품">{selectedProduct?.banner?.name}</td>
                                        <td data-label="덴탈잡 이용권 적용">
                                            {payloadTicket.banner.includes(selectedProduct?.banner?.ticketCode)
                                                ? 'O'
                                                : '-'}
                                        </td>
                                        <td data-label="금액" style={{ textAlign: 'end' }}>
                                            {payloadTicket.banner.includes(selectedProduct?.banner?.ticketCode)
                                                ? 0
                                                : formatNumberWithCommas(selectedProduct?.banner?.selectedPrice)}
                                            원
                                        </td>
                                    </tr>
                                )}
                                {selectedProduct?.bannerOp && (
                                    <tr>
                                        <td data-label="구분" style={{ textAlign: 'center' }}>
                                            {selectedProduct?.bannerOp?.duration}일
                                        </td>
                                        <td data-label="결제상품">{selectedProduct?.bannerOp?.name}</td>
                                        <td data-label="덴탈잡 이용권 적용">
                                            {payloadTicket.bannerOp.includes(selectedProduct?.bannerOp?.ticketCode)
                                                ? 'O'
                                                : '-'}
                                        </td>
                                        <td data-label="금액" style={{ textAlign: 'end' }}>
                                            {payloadTicket.bannerOp.includes(selectedProduct?.bannerOp?.ticketCode)
                                                ? 0
                                                : formatNumberWithCommas(selectedProduct?.bannerOp?.price)}
                                            원
                                        </td>
                                    </tr>
                                )}
                                {selectedProduct?.fixed && (
                                    <tr>
                                        <td data-label="구분" style={{ textAlign: 'center' }}>
                                            {selectedProduct?.fixed?.duration}일
                                        </td>
                                        <td data-label="결제상품">{selectedProduct?.fixed?.name}</td>
                                        <td data-label="덴탈잡 이용권 적용">
                                            {payloadTicket.fixed.includes(selectedProduct?.fixed?.ticketCode) ||
                                                payloadTicket.fixed.includes(selectedProduct?.fixed?.ticketCode14)
                                                ? 'O'
                                                : '-'}
                                        </td>
                                        <td data-label="금액" style={{ textAlign: 'end' }}>
                                            {payloadTicket.fixed.includes(selectedProduct?.fixed?.ticketCode) ||
                                                payloadTicket.fixed.includes(selectedProduct?.fixed?.ticketCode14)
                                                ? 0
                                                : formatNumberWithCommas(selectedProduct?.fixed?.selectedPrice)}
                                            원
                                        </td>
                                    </tr>
                                )}
                                {selectedProduct?.highlight && (
                                    <tr>
                                        <td data-label="구분" style={{ textAlign: 'center' }}>
                                            {selectedProduct?.highlight?.duration}일
                                        </td>
                                        <td data-label="결제상품">{selectedProduct?.highlight?.name}</td>
                                        <td data-label="덴탈잡 이용권 적용">
                                            {payloadTicket.highlight.includes(selectedProduct?.highlight?.ticketCode)
                                                ? 'O'
                                                : '-'}
                                        </td>
                                        <td data-label="금액" style={{ textAlign: 'end' }}>
                                            {payloadTicket.highlight.includes(selectedProduct?.highlight?.ticketCode)
                                                ? 0
                                                : formatNumberWithCommas(selectedProduct?.highlight?.price)}
                                            원
                                        </td>
                                    </tr>
                                )}
                                <tr className="byn__total">
                                    <td colSpan={3}>총 결제 금액:</td>
                                    <td style={{ textAlign: 'end' }}>{formatNumberWithCommas(totalPay)}원</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="byn__note red">
                            ※ 마이크로소프트 사에서 인터넷 익스플로러(Internet Explorer) 서비스 지원을 종료하여 인터넷
                            익스플로러에서 정상적인 결제가 되지 않을 수 있으니 크롬(Chrome)이나 엣지(Microsoft edge)
                            브러우저에서 결제를 진행해 주시기 바랍니다.
                        </div>
                    </div>
                    {!ticketPay && (
                        <div className="byn__block">
                            <div className="byn__tit">결제수단/증빙 선택</div>
                            <table className="byn__table">
                                <tbody>
                                    <tr className="byn__wrap">
                                        <th>
                                            <span className="byn__req">*</span>결제수단
                                        </th>
                                        <td>
                                            <fieldset className="byn_radio">
                                                <div className="item-radioBox">
                                                    <input
                                                        type="radio"
                                                        name="payment-method"
                                                        id="cardMethod"
                                                        value="Card"
                                                        checked={paymentMethod === 'Card' && !ticketPay}
                                                        onChange={(e) => setPaymentMethod(e.target.value)}
                                                        disabled={ticketPay}
                                                    />
                                                    <span />
                                                    <label htmlFor="cardMethod">
                                                        <span>신용카드</span>
                                                    </label>
                                                </div>
                                                <div className="item-radioBox">
                                                    <input
                                                        type="radio"
                                                        name="payment-method"
                                                        id="directBankMethod"
                                                        value="DirectBank"
                                                        checked={paymentMethod === 'DirectBank' && !ticketPay}
                                                        onChange={(e) => setPaymentMethod(e.target.value)}
                                                        disabled={ticketPay}
                                                    />
                                                    <span />
                                                    <label htmlFor="directBankMethod">
                                                        <span>실시간계좌이체</span>
                                                    </label>
                                                </div>
                                                <div className="item-radioBox">
                                                    <input
                                                        type="radio"
                                                        name="payment-method"
                                                        id="VBankMethod"
                                                        value="VBank"
                                                        checked={paymentMethod === 'VBank' && !ticketPay}
                                                        onChange={(e) => setPaymentMethod(e.target.value)}
                                                        disabled={ticketPay}
                                                    />
                                                    <span />
                                                    <label htmlFor="VBankMethod">
                                                        <span>무통장입금</span>
                                                    </label>
                                                </div>
                                            </fieldset>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className="byn__req">*</span>결제자 정보
                                        </th>
                                        <td className="wrap-column">
                                            <div className="byn__itxt">
                                                <span>성명:</span>
                                                <input
                                                    type="text"
                                                    placeholder="이름을 입력하세요"
                                                    value={payloadReceipt?.nameKor || ''}
                                                    name="nameKor"
                                                    onChange={handleChangeReceipt}
                                                    readOnly={ticketPay}
                                                />
                                            </div>
                                            <div className="byn__itxt">
                                                <span>휴대폰:</span>
                                                <input
                                                    type="text"
                                                    placeholder="휴대폰 번호를 입력하세요"
                                                    name="mobileNo"
                                                    value={payloadReceipt?.mobileNo || ''}
                                                    onChange={handleChangeReceipt}
                                                    readOnly={ticketPay}
                                                />
                                            </div>
                                            <div className="byn__itxt">
                                                <span>이메일:</span>
                                                <input
                                                    type="text"
                                                    placeholder="이름을 입력하세요"
                                                    name="email"
                                                    value={payloadReceipt?.email || ''}
                                                    onChange={handleChangeReceipt}
                                                    readOnly={ticketPay}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="byn__wrap">
                                        <th>결제 안내사항</th>
                                        <td className="td-wrap">
                                            <ul>
                                                <li>
                                                    채용광고 증빙서류 신청 현황 및 영수증 출력은 [My페이지 채용정보
                                                    관리/영수증] 메뉴에서 확인하실 수 있습니다.
                                                </li>
                                                <li>
                                                    결제 신청시, 승인 진행에 다소 시간이 소요될 수 있으므로 ‘중지’ ,
                                                    ‘새로고침’을 누르지 마시고 결과 화면이 나타날 때까지 기다려
                                                    주십시오.
                                                </li>
                                                <li className="blue">
                                                    DVmall 덴탈잡이용권은 DVmall사이트에서 할인된 가격으로 구입
                                                    가능합니다.
                                                </li>
                                                <li className="blue">
                                                    구입하신 DVmall 덴탈잡이용권은 DVmall에 인증된 비타민아이디와
                                                    덴탈잡에 로그인한 아이디가 동일한 경우 사용 가능합니다.
                                                </li>
                                                <li className="blue">
                                                    DVmall 덴탈잡이용권에 대한 증빙서류는 구입하신 DVmall 사이트에서
                                                    확인하시기 바랍니다.
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    {paymentMethod === 'Card' && (
                                        <tr className="byn__wrap">
                                            <th>신용카드 안내</th>
                                            <td>
                                                - 신용카드 매출전표는 부가가치세법 제32조의 2 제3항에 의하여 발행되며,
                                                동법 시행령 제57조 제2항에 의하여 세금계산서를 교부하지 않습니다.
                                            </td>
                                        </tr>
                                    )}
                                    {(paymentMethod === 'DirectBank' || paymentMethod === 'VBank') && (
                                        <>
                                            {paymentMethod === 'DirectBank' && (
                                                <tr className="byn__wrap">
                                                    <th>실시간계좌이체 안내</th>
                                                    <td className="td-wrap">
                                                        <ul>
                                                            <li>
                                                                결제금액이 입력하신 계좌에서 자동으로 이체되는 서비스로
                                                                계좌이체시 본인인증이 필요합니다.
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            )}

                                            {paymentMethod === 'VBank' && (
                                                <tr className="byn__wrap">
                                                    <th>무통장입금 안내</th>
                                                    <td className="td-wrap">
                                                        <ul>
                                                            <li>
                                                                무통장 입금 확인은 입금 후 최대 1시간 이내에 확인되며,
                                                                입금 확인시 채용광고가 게재가 됩니다.
                                                            </li>
                                                            <li>
                                                                입금확인이 하루 이상(주말, 공휴일 제외) 지속될 경우
                                                                고객센터로 연락주시기 바랍니다.
                                                            </li>
                                                            <li>
                                                                무통장 주문 후 5일이 지날때까지 입금이 되지 않으면
                                                                채용광고 게재는 자동으로 취소됩니다.
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            )}

                                            <tr>
                                                <th>
                                                    <span className="byn__req">*</span>현금영수증 발급
                                                </th>
                                                <td className="td-wrap">
                                                    <div className="wrap-top">
                                                        <div className="wrap-radioBox">
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    name="receiptType"
                                                                    value="company"
                                                                    checked={
                                                                        payloadReceipt.receiptType === 'company' &&
                                                                        !ticketPay
                                                                    }
                                                                    onChange={handleChangeReceipt}
                                                                    disabled={ticketPay}
                                                                />
                                                                <span className="title-value-radio">
                                                                    지출증빙용(사업자, 세금계산서대용)
                                                                </span>
                                                            </label>
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    name="receiptType"
                                                                    value="person"
                                                                    checked={
                                                                        payloadReceipt.receiptType === 'person' &&
                                                                        !ticketPay
                                                                    }
                                                                    onChange={handleChangeReceipt}
                                                                    disabled={ticketPay}
                                                                />
                                                                <span className="title-value-radio">
                                                                    소득공제용(개인)
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <label className="title-value-text">
                                                            <span>*신청번호(사업자번호, 핸드폰번호) : </span>
                                                            <input
                                                                type="text"
                                                                name="receiptNum"
                                                                placeholder="-없이 입력하세요"
                                                                value={payloadReceipt?.receiptNum || ''}
                                                                onChange={handleChangeReceipt}
                                                                readOnly={ticketPay}
                                                            />
                                                        </label>
                                                    </div>
                                                    <div className="wrap-bottom">
                                                        <div className="title">※현금영수증 발급 안내</div>
                                                        <ul>
                                                            <li>
                                                                현금영수증(지출증빙)은 법인세법 116조 2항 및
                                                                부가가치세법 32조 2의 3항에 의해 세금계산서와 동일한
                                                                자격 및 효력이 있습니다
                                                            </li>
                                                            <li>
                                                                세금계산서를 원할 경우 현금영수증(지출증빙)으로
                                                                신청하시면 세금계산서 대용으로 세액공제를 받을 수
                                                                있습니다.
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
                <button
                    type="button"
                    className="byn__btn"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    style={isSubmitting ? { opacity: 0.6, cursor: 'not-allowed' } : undefined}
                >
                    {isSubmitting ? '처리중...' : '등록내용확인 및 결제하기'}
                </button>
            </div>

            {/* {isPopupOpen && <PopupPAJAC030 closePopup={closePopup} />} */}
        </>
    );
};
export default PAJAC030;
